/**
 * The Cbutton VISUAL-SURFACE marker.
 *
 * A non-inline `Cbutton` renders two nested elements: a semantic root (the
 * `role="button"` hit wrapper, square and unstyled) wrapping exactly one
 * `Ccontainer`. That `Ccontainer`'s root element is the visual surface — it
 * carries the button's resolved corner radius, background, border and shadow.
 * The content wrapper inside it is square again.
 *
 * Consumers that must measure what the user actually SEES (e.g. the teams
 * carousel's morph-flight source rect) need to reach that one element from an
 * arbitrary position in the subtree. This attribute is the seam. Producer
 * (Cbutton) and consumer both key off the constants here so they cannot drift.
 *
 * Only the non-inline surface is marked. The `inline` variant renders a span
 * surface for prose embedding and is deliberately NOT a match, so a marked
 * surface always means "a measurable card-like button face".
 */
export const CBUTTON_SURFACE_ATTRIBUTE = "data-cbutton-surface";

/** Presence is the signal; the value carries no meaning. */
export const CBUTTON_SURFACE_ATTRIBUTE_VALUE = "";

/** CSS selector matching the marked surface element. */
export const CBUTTON_SURFACE_SELECTOR = `[${CBUTTON_SURFACE_ATTRIBUTE}]`;

/**
 * Ready-to-spread attribute bag for the surface `Ccontainer` root. Module-level
 * so the reference is stable across renders (Cbutton memoizes that subtree).
 */
export const CBUTTON_SURFACE_ROOT_ATTRIBUTES = {
  [CBUTTON_SURFACE_ATTRIBUTE]: CBUTTON_SURFACE_ATTRIBUTE_VALUE,
} as const;
